import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, text, icon, border, padding, margin } from '@rexlabs/styling';
import CloseIcon from '@rexlabs/icons/large/close.svg';
import { isString } from 'lodash';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    overflow: 'hidden'
  }, text.styles({
    target: 'tag',
    fallback: 'small.semibold'
  })), border.styles({
    target: 'tag',
    all: {
      color: function color(_ref) {
        var token = _ref.token;
        return token('tag.background.color', token('color.border.neutral.idle.contrast'));
      },
      radius: 'm',
      width: 'thin'
    }
  })), padding.styles({
    target: 'tag',
    x: 's',
    y: 'xxs'
  })), {}, {
    width: function width(_ref2) {
      var token = _ref2.token;
      return token('tag.width', 'auto');
    },
    height: function height(_ref3) {
      var token = _ref3.token;
      return token('tag.height', '2.8rem');
    },
    maxWidth: function maxWidth(_ref4) {
      var token = _ref4.token;
      return token('tag.maxWidth', '100%');
    },
    backgroundColor: function backgroundColor(_ref5) {
      var token = _ref5.token;
      return token('tag.background.color', token('color.neutral.idle.contrast'));
    }
  }),
  fullWidth: {
    width: '100%'
  },
  hasButton: _objectSpread({}, padding.styles({
    right: 'xxs'
  })),
  containerInteractive: {
    cursor: 'pointer',
    '&:hover': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'tag.hover'
    })), border.styles({
      target: 'tag.hover'
    })), {}, {
      backgroundColor: function backgroundColor(_ref6) {
        var token = _ref6.token;
        return token('tag.hover.background.color', token('tag.background.color'));
      }
    })
  },
  containerActive: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: ['tag.active', 'tag']
  })), border.styles({
    target: ['tag.active', 'tag']
  })), {}, {
    backgroundColor: function backgroundColor(_ref7) {
      var token = _ref7.token;
      return token('tag.active.background.color', token('tag.background.color'));
    }
  }),
  containerInteractiveActive: {
    '&:hover': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: ['tag.active.hover', 'tag.hover']
    })), border.styles({
      target: ['tag.active.hover', 'tag.hover']
    })), {}, {
      backgroundColor: function backgroundColor(_ref8) {
        var token = _ref8.token;
        return token('tag.active.hover.background.color', token('tag.hover.background.color'));
      }
    })
  },
  containerDisabled: _objectSpread(_objectSpread(_objectSpread({
    cursor: 'default'
  }, text.styles({
    target: ['tag.disabled', 'tag']
  })), border.styles({
    target: ['tag.disabled', 'tag']
  })), {}, {
    backgroundColor: function backgroundColor(_ref9) {
      var token = _ref9.token;
      return token('tag.disabled.background.color', token('tag.background.color'));
    },
    opacity: function opacity(_ref10) {
      var token = _ref10.token;
      return token('tag.disabled.opacity', 0.5);
    },
    '&:hover': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: ['tag.disabled', 'tag']
    })), border.styles({
      target: ['tag.disabled', 'tag']
    })), {}, {
      backgroundColor: function backgroundColor(_ref11) {
        var token = _ref11.token;
        return token('tag.disabled.background.color', token('tag.background.color'));
      }
    })
  }),
  label: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > svg': _objectSpread({}, icon.styles({
      target: 'tag',
      size: 's'
    }))
  },
  iconLeft: _objectSpread({}, margin.styles({
    target: 'tag.icon.left',
    right: 'xs'
  })),
  iconRight: _objectSpread({}, margin.styles({
    target: 'tag.icon.right',
    left: 'xs'
  })),
  closeButton: _objectSpread(_objectSpread(_objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    // Button reset
    border: '0 none',
    padding: 0
  }, text.styles({
    target: 'tag.closeButton',
    color: function color() {
      return 'inherit';
    }
  })), border.styles({
    target: 'tag.closeButton',
    all: {
      radius: 'm'
    }
  })), {}, {
    height: function height(_ref12) {
      var token = _ref12.token;
      return token('tag.closeButton.height', '2rem');
    },
    width: function width(_ref13) {
      var token = _ref13.token;
      return token('tag.closeButton.width', '2rem');
    },
    backgroundColor: function backgroundColor(_ref14) {
      var token = _ref14.token;
      return token('tag.closeButton.background.color', token('palette.tint.light.400'));
    },
    '& > svg': _objectSpread({}, icon.styles({
      target: 'tag.closeButton',
      size: 'l'
    }))
  }),
  closeButtonActive: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: ['tag.closeButton.active', 'tag.closeButton']
  })), border.styles({
    target: 'tag.closeButton.active'
  })), {}, {
    backgroundColor: function backgroundColor(_ref15) {
      var token = _ref15.token;
      return token('tag.closeButton.active.background.color');
    }
  }),
  closeButtonDisabled: {
    cursor: 'default'
  }
});
var displayName = 'CoreTag';
/**
 * Tags can be used to display small bits of contextually related information depsnding on where the tag is places in the document. They can also be used as interactive elements that will achieve some function, whether it's displaying removable tags within a select, or updating table filters through a popout.
 */

export var CoreTag = /*#__PURE__*/forwardRef(function (_ref16, ref) {
  var children = _ref16.children,
      _ref16$fullWidth = _ref16.fullWidth,
      fullWidth = _ref16$fullWidth === void 0 ? false : _ref16$fullWidth,
      _ref16$isInteractive = _ref16.isInteractive,
      isInteractive = _ref16$isInteractive === void 0 ? false : _ref16$isInteractive,
      _ref16$isDisabled = _ref16.isDisabled,
      isDisabled = _ref16$isDisabled === void 0 ? false : _ref16$isDisabled,
      _ref16$isActive = _ref16.isActive,
      isActive = _ref16$isActive === void 0 ? false : _ref16$isActive,
      handleClear = _ref16.handleClear,
      PropIcon = _ref16.Icon,
      IconLeft = _ref16.IconLeft,
      IconRight = _ref16.IconRight,
      rest = _objectWithoutProperties(_ref16, ["children", "fullWidth", "isInteractive", "isDisabled", "isActive", "handleClear", "Icon", "IconLeft", "IconRight"]);

  var s = useStyles(defaultStyles, displayName);
  var interactive = !isDisabled && isInteractive;
  var Icon = PropIcon !== null && PropIcon !== void 0 ? PropIcon : IconLeft;
  var showRightIcon = handleClear || IconRight;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    flex: 0,
    alignItems: "center",
    tabIndex: interactive ? 0 : undefined
  }, s('container', {
    fullWidth: fullWidth,
    hasButton: !!handleClear,
    containerInteractive: interactive,
    containerActive: isActive,
    containerInteractiveActive: interactive && isActive,
    containerDisabled: isDisabled
  }), rest), Icon && /*#__PURE__*/React.createElement("span", s('icon', 'iconLeft'), /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      overflow: 'hidden'
    },
    flex: 1,
    title: isString(children) ? children : undefined
  }, /*#__PURE__*/React.createElement(Box, s('label'), children)), showRightIcon && /*#__PURE__*/React.createElement("span", s('icon', 'iconRight'), handleClear ? /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, s('closeButton', {
    closeButtonActive: isActive,
    closeButtonDisabled: isDisabled
  }), {
    disabled: isDisabled,
    onClick: handleClear
  }), /*#__PURE__*/React.createElement(CloseIcon, null)) : IconRight ? /*#__PURE__*/React.createElement(IconRight, null) : null));
});
CoreTag.displayName = displayName;
export default CoreTag;